import { db } from '../firebase';
import {
  collection, addDoc, getDocs, updateDoc, deleteDoc,
  doc, query, orderBy, limit, serverTimestamp,
} from 'firebase/firestore';

// ─── Weight Logs ───────────────────────────────────────────
export const addWeightLog = (uid, data) =>
  addDoc(collection(db, 'users', uid, 'weightLogs'), { ...data, loggedAt: serverTimestamp() });

export const getWeightLogs = async (uid, limitNum = 90) => {
  const q = query(collection(db, 'users', uid, 'weightLogs'), orderBy('loggedAt', 'desc'), limit(limitNum));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

// ─── Workout Logs ──────────────────────────────────────────
export const addWorkoutLog = (uid, data) =>
  addDoc(collection(db, 'users', uid, 'workoutLogs'), { ...data, loggedAt: serverTimestamp() });

export const getWorkoutLogs = async (uid, limitNum = 30) => {
  const q = query(collection(db, 'users', uid, 'workoutLogs'), orderBy('loggedAt', 'desc'), limit(limitNum));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

// ─── Medication Logs ───────────────────────────────────────
export const addMedication = (uid, data) =>
  addDoc(collection(db, 'users', uid, 'medications'), { ...data, createdAt: serverTimestamp() });

export const getMedications = async (uid) => {
  const snap = await getDocs(collection(db, 'users', uid, 'medications'));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const logMedicationTaken = (uid, data) =>
  addDoc(collection(db, 'users', uid, 'medicationLogs'), { ...data, takenAt: serverTimestamp() });

export const deleteMedication = (uid, medId) =>
  deleteDoc(doc(db, 'users', uid, 'medications', medId));

// ─── Blood Pressure Logs ───────────────────────────────────
export const addBPLog = (uid, data) =>
  addDoc(collection(db, 'users', uid, 'bpLogs'), { ...data, loggedAt: serverTimestamp() });

export const getBPLogs = async (uid, limitNum = 30) => {
  const q = query(collection(db, 'users', uid, 'bpLogs'), orderBy('loggedAt', 'desc'), limit(limitNum));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

// ─── Nutrition Logs ────────────────────────────────────────
export const addNutritionLog = (uid, data) =>
  addDoc(collection(db, 'users', uid, 'nutritionLogs'), { ...data, loggedAt: serverTimestamp() });

export const getNutritionLogs = async (uid, limitNum = 30) => {
  const q = query(collection(db, 'users', uid, 'nutritionLogs'), orderBy('loggedAt', 'desc'), limit(limitNum));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

// ─── Supplement Logs ───────────────────────────────────────
export const addSupplementLog = (uid, data) =>
  addDoc(collection(db, 'users', uid, 'supplementLogs'), { ...data, loggedAt: serverTimestamp() });

export const getSupplementLogs = async (uid, limitNum = 30) => {
  const q = query(collection(db, 'users', uid, 'supplementLogs'), orderBy('loggedAt', 'desc'), limit(limitNum));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const deleteSupplementLog = (uid, logId) =>
  deleteDoc(doc(db, 'users', uid, 'supplementLogs', logId));

// ─── User Goals ────────────────────────────────────────────
export const updateUserGoals = (uid, goals) =>
  updateDoc(doc(db, 'users', uid), { goals, updatedAt: serverTimestamp() });
